import { AemRrpProduct, AemRrpProductSmallImage } from '../types/product.types';
import { GenericOffer, PaymentOffer } from '@common-modules/product-catalogue';
import { RrpPromo } from '../types/rrp-promo.types';

export interface GetProductBySkuReturnValue {
  [key: string]: {
    productId: string;
    ribbonText: string;
    smallImage: AemRrpProductSmallImage;
    maxAllowedQuantity: number;
    tags: string[];
    shippingLiner: string;
  };
}

export const getProductBySku = (
  products: AemRrpProduct[]
): GetProductBySkuReturnValue => {
  const variantBySku = products.reduce((acc, cur) => {
    cur.variants.forEach(variant => {
      const { sku, ...data } = variant;
      if (!(sku in acc)) {
        acc[sku] = {
          ...data,
          productId: cur.id,
          maxAllowedQuantity: cur.maxAllowedQuantity,
          tags: cur.tags,
          shippingLiner: cur.shippingLiner
        };
      }
    });
    return acc;
  }, {});

  return variantBySku;
};

export const getApplicablePromos = (
  promos: RrpPromo[],
  groupId: string
): { genericOffers: GenericOffer[]; paymentOffers: PaymentOffer[] } => {
  const genericOffers: GenericOffer[] = [];
  const paymentOffers: PaymentOffer[] = [];

  for (const promo of promos) {
    const rrpIds = promo.rrpList
      .split(',')
      .map(id => id.trim())
      .filter(Boolean);

    const isInList = rrpIds.includes(groupId);
    const isApplicable =
      (promo.promoType === 'include' && isInList) ||
      (promo.promoType === 'exclude' && !isInList);

    if (isApplicable) {
      genericOffers.push(...(promo.genericOffer || []));
      paymentOffers.push(...(promo.paymentOffer || []));
    }
  }

  return { genericOffers, paymentOffers };
};
